/**
 * @generated SignedSource<<638952596246d773f78c7b182f5a70a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PasswordEditReissueMutation$variables = {
  email: string;
};
export type PasswordEditReissueMutation$data = {
  readonly reissuePassword: {
    readonly email: string;
  };
};
export type PasswordEditReissueMutation = {
  response: PasswordEditReissueMutation$data;
  variables: PasswordEditReissueMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PasswordEditReissueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReissuePasswordMutationPayload",
        "kind": "LinkedField",
        "name": "reissuePassword",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PasswordEditReissueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReissuePasswordMutationPayload",
        "kind": "LinkedField",
        "name": "reissuePassword",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "66b1cdd007968e6520dd15859e5decdc",
    "id": null,
    "metadata": {},
    "name": "PasswordEditReissueMutation",
    "operationKind": "mutation",
    "text": "mutation PasswordEditReissueMutation(\n  $email: String!\n) {\n  reissuePassword(input: {email: $email}) {\n    email\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6a9f7a166fa683a8e93faaad07bcdbc2";

export default node;
